import React, { Component } from 'react';
import { Modal, Button, Input, Checkbox, DatePicker, Select, message, Icon } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import SearchMulSelect from '../../common/SearchMulSelect';
import SelectProvince from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';

const Option = Select.Option;
const InputGroup = Input.Group;
const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;
const disabledDate = (current, date) => {
    const prevValue = moment(date).subtract(11, 'M').valueOf();
    const nextValue = moment(date).add(11, 'M').valueOf();
    const currentValue = current.valueOf();
    return current && (currentValue < prevValue || currentValue > nextValue);
};


class Filter extends Component {
    state = {
        maxMonth: moment().format(monthFormat),
        searchParams: {
            oper: 'GT',
            isPresent: false,
        },
        departmentList: [],
        userOptions: [],
        managerOptions: [],
        leaderOptions: [],
        positionOptions: [],
        businessList: [],
        stageList: [],
        enterpriseDepartmentList: [],
        showPosition: true,
        reRender: false,
        expand: false,
    }

    componentDidMount() {
        this.queryRecentRecordTime();
        this.queryWithLevelByParams();
        this.loadTypeConfigureList();
        this.queryUserDepartmentList();
    }

    queryUserDepartmentList = () => {
        dictCache.getDict('USER_DEPT_LEVEL_5', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.user.queryUserDepartmentSelect,
                data: { level: 5 },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { data, error } = res;
            if (!error) {
                this.setState({
                    enterpriseDepartmentList: data,
                    departmentList: data,
                });
            } else {
                Modal.error({ title: error });
            }
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    queryRecentRecordTime = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryRecentRecordTime,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                const maxMonth = date || moment().format(monthFormat);
                searchParams.begin = maxMonth;
                searchParams.end = maxMonth;
                this.setState({
                    maxMonth,
                    searchParams,
                }, () => {
                    this.search();
                })
            }
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ stageList: res.stageList });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        const { begin, end } = searchParams;
        if(!begin){
            message.warning(`请选择工作日期开始时间`);
            return;
        }
        if(!end){
            message.warning(`请选择工作日期结束时间`);
            return;
        }
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    reset = () => {
        this.setState({
            searchParams: {
                oper: 'GT',
                isPresent: false,
            },
            departmentList: [],
            userOptions: [],
            managerOptions: [],
            leaderOptions: [],
            positionOptions: [],
            reRender: true,
        }, () => {
            this.setState({ reRender: false }, () => {
                this.queryRecentRecordTime();
            });
        });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const params = {};
        checkedArea.map(item => {
            params[`params[${item.props.title}]`] = item.key;
        });
        searchParams.areaParams = params;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        const { begin, end } = searchParams;
        if (key === 'begin') {
            if (moment(dateString).valueOf() > moment(end).valueOf()) {
                message.warning('开始时间不能大于结束时间！');
                return;
            }
            if (moment(dateString).valueOf() < moment(end).subtract(11, 'M').valueOf()) {
                message.warning('开始时间超出范围！');
                return;
            }
        } else if (key === 'end') {
            if (moment(dateString).valueOf() < moment(begin).valueOf()) {
                message.warning('结束时间不能小于开始时间！');
                return;
            }
            if (moment(dateString).valueOf() > moment(begin).add(11, 'M').valueOf()) {
                message.warning('结束时间超出范围！');
                return;
            }
        }
        searchParams[key] = dateString
        this.setState({ searchParams });
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleCheckBoxChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.checked;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { departmentList, searchParams } = this.state;
        if (key == 'departmentId') {
            searchParams[key] = value;
            searchParams.departmentName = (departmentList.find(i => i.enterpriseDepartmentId == value) || {}).enterpriseDepartmentName;
            searchParams.positionIds = '';
            this.setState({
                searchParams,
                showPosition: false,
                positionOptions: [],
            }, () => {
                this.setState({ showPosition: true })
            });
        } else if (key === 'stageIds') {
            searchParams[key] = value ? value.join(',') : undefined;
            this.setState({ searchParams });
        } else if (key === 'lineOfBusiness') {
            searchParams[key] = value;
            searchParams.secondLineName = undefined;
            this.setState({ searchParams });
        } else if (key === 'status') {
            searchParams[key] = value;
            searchParams.leftTime = undefined;
            this.setState({ searchParams });
        } else if (key === 'enterpriseDepartmentId') {
            searchParams[key] = value;
            searchParams.xjDeptId = undefined;
            searchParams.xjDeptName = undefined;
            searchParams.positionId = undefined;
            searchParams.positionName = undefined;
            this.setState({ searchParams });
        } else {
            searchParams[key] = value;
            this.setState({ searchParams });
        }
    }

    //职位
    positionSelectChange = (value = []) => {
        const { searchParams } = this.state;
        let positionIds = '';
        value.map(item => {
            positionIds += `,${item.key}`;
        });
        searchParams.positionIds = positionIds ? positionIds.slice(1) : '';
        this.setState({ searchParams });
    }

    parsePositionData = res => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.positionName}`,
                value: item.positionId,
                fetching: false,
            }));
            this.setState({ positionOptions: data });
        } else {
            this.setState({ positionOptions: [] });
        }
    }

    getDynamicParams = () => {
        const { departmentId = '' } = this.state.searchParams;
        if (departmentId){
            return {departmentId};
        }
        // message.warning('请先选择所属部门');
        return null;
    }

    //直线主管
    leaderSelectChange = (value = []) => {
        const { searchParams } = this.state;
        let leaderIds = '';
        value.map(item => {
            leaderIds += `,${item.key}`;
        });
        searchParams.leaderIds = leaderIds ? leaderIds.slice(1) : '';
        this.setState({ searchParams });
    }

    parseLeaderData = res => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
                fetching: false,
            }));
            this.setState({ leaderOptions: data });
        } else {
            this.setState({ leaderOptions: [] });
        }
    }

    saveData = (data, key) => {
        const { searchParams } = this.state;
        searchParams[key] = data;
        this.setState({ searchParams });
    }

    handleChange = ({ value, text }, key) => {
        const { searchParams } = this.state;
        searchParams[`${key}Id`] = value;
        searchParams[`${key}Name`] = text;
        this.setState({ searchParams });
    }

    handleSearchRetrieveChange = (option, key) => {
        const { searchParams } = this.state;
        const { value, text } = option || {};
        switch (key) {
            case 'xjDept':
                searchParams.xjDeptId = value;
                searchParams.xjDeptName = text;
                searchParams.positionId = undefined;
                searchParams.positionName = undefined;
                break;
            case 'position':
                searchParams.positionId = value;
                searchParams.positionName = text;
                break;
            default:
                break;
        }
        this.setState({
            searchParams,
        });
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { type } = this.props;
        const { searchParams, departmentList, positionOptions, leaderOptions, showPosition, expand, reRender, businessList, stageList, enterpriseDepartmentList } = this.state;
        const { begin, end, isPresent, departmentId, jdeMainCode, jdeCode, investigationName, investigationSiteName, leftTime, status, oper, userName, projectManagerAName, lineOfBusiness, enterpriseDepartmentId, xjDeptId, positionName } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const departmentOptions = departmentList.map(item => <Option key={String(item.enterpriseDepartmentId)}>{item.enterpriseDepartmentName}</Option>);
        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>);
        const enterpriseDepartmentOptions = enterpriseDepartmentList.map(el => <Option value={el.enterpriseDepartmentId}>{el.enterpriseDepartmentName}</Option>)
        const maxHeight = expand ? 200 : 40;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar expand" style={{ maxHeight: maxHeight }}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">工作日期</label>
                        <MonthPicker
                            allowClear={false}
                            placeholder="请选择"
                            format={monthFormat}
                            disabled={isPresent}
                            style={{ width: 100 }}
                            value={begin ? moment(begin) : null}
                            disabledDate={current => disabledDate(current, moment(begin))}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'begin')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            allowClear={false}
                            placeholder="请选择"
                            format={monthFormat}
                            disabled={isPresent}
                            style={{ width: 100 }}
                            value={end ? moment(end) : null}
                            disabledDate={current => disabledDate(current, moment(end))}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'end')}
                        />
                    </div>
                    {
                        type === 'investigation' &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">
                                <Checkbox
                                    onChange={e => this.handleCheckBoxChange(e, 'isPresent')}
                                    checked={isPresent}
                                >项目开始-至今</Checkbox>
                            </label>
                        </div>
                    }
                    <div className="search-item">
                        <label className="ui-label">员工</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 142 }}
                            params={{ limit: 20 }}
                            value={userName}
                            placeholder="输入姓名/工号检索"
                            url={API_URL.team.userlist}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'user')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">工作城市</label>
                        {
                            !reRender &&
                            <SelectProvince saveProvince={this.saveProvince} />
                        }
                    </div>
                    <div className="search-item">
                    <label htmlFor="" className="ui-label">部门</label>
                    <Select
                        style={{ width: 160 }}
                        allowClear={true}
                        placeholder="请选择"
                        value={enterpriseDepartmentId}
                        onChange={value => this.handleSelectChange(value, 'enterpriseDepartmentId')}
                    >
                        {enterpriseDepartmentOptions}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">下级组织</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入下级组织检索"
                        value={xjDeptId}
                        params={{ limit: 20, level: 6, parentId: enterpriseDepartmentId }}
                        url={API_URL.user.queryUserDepartmentSelect}
                        config={{ id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'xjDept')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位级别</label>
                    <SearchRetrieve
                        keyword='positionName'
                        style={{ width: 142 }}
                        placeholder="输入职位检索"
                        value={positionName}
                        params={{ limit: 20, enterpriseDepartmentId: xjDeptId ? xjDeptId : enterpriseDepartmentId}}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'position')}
                    />
                </div>
                    <div className="search-item">
                        <label className="ui-label">直线主管</label>
                        {
                            !reRender &&
                            <SearchMulSelect
                                keyword='keyword'
                                style={{width: 150}}
                                className="usermanhour-multiple"
                                url={API_URL.team.userlist}
                                sourceData={leaderOptions}
                                parseData={this.parseLeaderData}
                                handleSelect={this.leaderSelectChange}
                                placeholder={'请输入姓名或工号'}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE主项目号</label>
                        <Input placeholder="请输入" value={jdeMainCode} onChange={e => this.handleInputChange(e, 'jdeMainCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE项目号</label>
                        <Input placeholder="请输入" value={jdeCode} onChange={e => this.handleInputChange(e, 'jdeCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目简称</label>
                        <Input style={{width: 150}} placeholder="请输入" value={investigationName} onChange={e => this.handleInputChange(e, 'investigationName')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">大项目经理</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 142 }}
                            params={{ limit: 20 }}
                            value={projectManagerAName}
                            placeholder="输入姓名/工号检索"
                            url={API_URL.team.userlist}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'projectManagerA')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">研究中心名称</label>
                        <Input placeholder="请输入" value={investigationSiteName} onChange={e => this.handleInputChange(e, 'investigationSiteName')}/>
                    </div>
                    <div className="search-item">
                            <label htmlFor="" className="ui-label">目前状态</label>
                            <Select
                                placeholder="请选择"
                                value={status}
                                onChange={value => this.handleSelectChange(value, 'status')}
                                style={{width:90}}
                                allowClear={true}
                            >
                                <Option value="WORKING">在职</Option>
                                <Option value="LEFT">离职</Option>
                            </Select>
                    </div>
                    <div className="search-item">
                            <label htmlFor="" className="ui-label">离职日期</label>
                            <InputGroup compact>
                                <Select value={oper} onChange={value => this.handleSelectChange(value, 'oper')}>
                                    <Option value="GT">&gt;</Option>
                                    <Option value="GE">&ge;</Option>
                                    <Option value="LT">&lt;</Option>
                                    <Option value="LE">&le;</Option>
                                    <Option value="EQ">=</Option>
                                </Select>
                                <DatePicker
                                    format={dateFormat}
                                    placeholder="请选择"
                                    style={{ width: 100 }}
                                    disabled={status !== 'LEFT'}
                                    value={leftTime ? moment(leftTime) : null}
                                    onChange={(date, dateString) => this.handleDateChange(date, dateString, 'leftTime')}
                                    allowClear={true}
                                />
                            </InputGroup>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleSelectChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    {
                        type === 'investigation' &&
                        <div className="search-item" style={{ height: 30 }}>
                            <label htmlFor="" className="ui-label">项目阶段</label>
                            <Select
                                className="multiple-stage"
                                mode="multiple"
                                filterOption={false}
                                placeholder="请选择"
                                style={{ width: 136 }}
                                value={searchParams.stageIds ? searchParams.stageIds.split(',') : []}
                                onChange={value => this.handleSelectChange(value, 'stageIds')}
                            >
                                {stageOption}
                            </Select>
                        </div>
                    }
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.reset}>重置</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/manHour/Filter.js